import { BooleanFlags, StaticFlags } from '../StaticFlagsHook.types';
import { AppSubdomains } from 'src/types/common';
import { flagsConfig } from '../config/flagsConfig';

export default function getBooleanFlags(
  subdomain: AppSubdomains
): Record<BooleanFlags, boolean> {
  const config = flagsConfig[subdomain];
  const defaultValue = config.strategy === 'enabled';

  const booleanFlags = Object.values(StaticFlags).filter(
    (flag) => flag !== StaticFlags.LaunchNotifications
  ) as BooleanFlags[];

  return booleanFlags.reduce(
    (acc, flag) => {
      acc[flag] = config.exceptions.includes(flag)
        ? !defaultValue
        : defaultValue;
      return acc;
    },
    {} as Record<BooleanFlags, boolean>
  );
}
